import { shared_Company_retrieveAll_filter, shared_Company_retrieveAll_order } from '../../../services/api/api';
import { SbCompaniesListColumn } from '../../../services/global/global-interfaces';

export const clientColumnDefaultsCompanies: Record<string, SbCompaniesListColumn[]> = {
  pmg: [
    // SELECTED START
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.ID,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.ID,
      canFilter: true,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'Name',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.NAME,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.NAME,
      canFilter: true,
    },
    { id: 'CustStatus', title: 'CustStatus', selected: true, type: 'COMPANY_ATTRIBUTE' },
    { id: 'CustSapKeyOfn', title: 'SAP-CustNr', selected: true, type: 'COMPANY_ATTRIBUTE' },
    { id: 'CustName', title: 'CustName', selected: true, type: 'COMPANY_ATTRIBUTE' },
    { id: 'CustName2', title: 'CustName2', selected: true, type: 'COMPANY_ATTRIBUTE' },
    {
      id: 'address.zip',
      title: 'address.zip',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.ZIP,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.ZIP,
      canFilter: true,
    },
    {
      id: 'address.city',
      title: 'address.city',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.CITY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.CITY,
      canFilter: true,
    },
    {
      id: 'address.street',
      title: 'address.street',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STREET,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STREET,
      canFilter: true,
    },
    { id: 'address', title: 'Address', selected: true, type: 'PROPERTY' },
    {
      id: 'ParentCustSapKey',
      title: 'SAP-ParentCustNr',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    {
      id: 'ParentCustName',
      title: 'SAP-ParentCustName',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    // SELECTED END

    {
      id: 'created',
      title: 'created',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.CREATED_AT,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.CREATED_AT,
      canFilter: true,
    },
    {
      id: 'address.borough',
      title: 'address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.BOROUGH,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.BOROUGH,
      canFilter: true,
    },
    {
      id: 'address.country',
      title: 'address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.COUNTRY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.COUNTRY,
      canFilter: true,
    },
    {
      id: 'address.county',
      title: 'address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.COUNTY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.COUNTY,
      canFilter: true,
    },
    {
      id: 'address.state',
      title: 'address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STATE,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STATE,
      canFilter: true,
    },
    {
      id: 'address.street',
      title: 'address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STREET,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STREET,
      canFilter: true,
    },
    {
      id: 'address.street2',
      title: 'address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STREET2,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STREET2,
      canFilter: true,
    },
  ],
  generic: [
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.ID,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.ID,
      canFilter: true,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: true,
      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'Name',
      selected: true,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.NAME,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.NAME,
      canFilter: true,
    },
    {
      id: 'created',
      title: 'created',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.CREATED_AT,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.CREATED_AT,
      canFilter: true,
    },
    { id: 'address', title: 'Address', selected: true, type: 'PROPERTY' },
    {
      id: 'address.borough',
      title: 'address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.BOROUGH,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.BOROUGH,
      canFilter: true,
    },
    {
      id: 'address.city',
      title: 'address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.CITY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.CITY,
      canFilter: true,
    },
    {
      id: 'address.country',
      title: 'address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.COUNTRY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.COUNTRY,
      canFilter: true,
    },
    {
      id: 'address.county',
      title: 'address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.COUNTY,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.COUNTY,
      canFilter: true,
    },
    {
      id: 'address.state',
      title: 'address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STATE,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STATE,
      canFilter: true,
    },
    {
      id: 'address.street',
      title: 'address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STREET,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STREET,
      canFilter: true,
    },
    {
      id: 'address.street2',
      title: 'address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.STREET2,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.STREET2,
      canFilter: true,
    },
    {
      id: 'address.zip',
      title: 'address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: shared_Company_retrieveAll_order.ZIP,
      canOrder: true,
      filterId: shared_Company_retrieveAll_filter.ZIP,
      canFilter: true,
    },
  ],
};
